import { Component } from 'react'

class IndexPage extends Component {
  state = {
    index: 0,
  }

  handleClick = () => {
  }

  render() {
    return null
  }
}

export default IndexPage
